<template>
  <v-dialog v-model="dialogStore.show" max-width="500">
    <v-card>
      <v-card-title class="text-h6">
        Thông báo
      </v-card-title>
      <v-card-text>
        <pre style="white-space: pre-wrap; word-break: break-word">{{
          dialogStore.message
        }}</pre>
        <ul
          v-if="dialogStore.unread && dialogStore.unread.length"
          style="margin-top: 1em"
        >
          <li v-for="(item, idx) in dialogStore.unread" :key="idx">
            <span v-if="item.content" v-html="item.content" />
            <span v-else>{{ JSON.stringify(item) }}</span>
          </li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="dialogStore.close">
          Đóng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { useDialogStore } from "@/stores/dialogStore";
const dialogStore = useDialogStore();
</script>
